import React from 'react';
import Styles from './PartiuGpGanhador.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function PartiuGpGanhador() {
  return (
    <section id="partiu-gp-ganhador">
      <ContainerHome24>
        <p className="eyebrow">Em breve</p>
        <h2 className="titulo">Conheça o ganhador</h2>
        <p className="subtitulo">Confira o ganhador a partir de 05/03/2027</p>
      </ContainerHome24>
      <style jsx>{Styles}</style>
    </section>
  );
}

export default PartiuGpGanhador;
